enum Broker {
  NONE = '',
  TRADESTATION = 'tradestation',
  TRADIER = 'tradier',
  SCHWAB = 'schwab',
}

export default Broker
